export class BitmapMetadata {
  public bitsPerPixel = 0;
}
